import * as React from 'react';
import { Switch, Route, withRouter, RouteComponentProps } from 'react-router-dom';
import FormAccount from './FormAccount';
import ListAccount from './ListAccount';
import { connect } from 'react-redux';
import { IStateApp } from '../../Reducers/index';
import { IPageOptions } from '../../Models/Common';
import { createActionCleanAccountStatus, createActionfetchAccounts, createActionFetchAccount, createActionCreateAccount, createActionCleanAccount, createActionDelete, createActionStatusAccount } from '../../Actions/Account/Actions';
import { IAccountState } from '../../Reducers/Account/index';
import { createActionFetchProducer } from '../../Actions/Producer/Actions';
import { Producer } from '../../Models/Report';
import { createActionFetchProfiles } from '../../Actions/Profile/Actions';
import { IProfile } from '../../Models/Security';
import { IAccountForm } from '../../Models/Account';
import Loading from '../../Components/Loading';
import { EStatusRequest } from '../../Reducers/Session';

export interface IAccountContainerProps extends  IAccountState, RouteComponentProps {
	onFetchAccountPage: (option: IPageOptions, idProfile?: number, search?: string, order?: string) => void;
	onCreateAccount: (data: IAccountForm, id?: number) => void;
	onFetchAccount: (id: number) => void
	onFetchProducers: () => void;
	onFetchProfiles: () => void;
	onCleanCurrent: () => void;
	onCleanStatus: () => void;
	onDeleteAccount: (id: number) => void;
	producers: Producer[];
	profiles: IProfile[];
	setStatusRequest: (status: EStatusRequest) => void;
}

class AccountContainer  extends React.Component<IAccountContainerProps> {
	private id?: number;
	private request: boolean = false;

	componentDidMount() {
		this.props.onFetchAccountPage({ page: 0, size: 5 })
		this.props.onFetchProducers();
		this.props.onFetchProfiles();
	}

	render() {
		return (<Switch>
			<Route path="/administration/create" render={(props: any) => {
				this.id = undefined;
				return <FormAccount
									message={this.props.messageFail}
									status={this.props.status}
									onCleanStatus={this.props.onCleanStatus}
									isRequest={this.props.isRequest}
									history={props.history}
									location={props.location}
									match={props.match}
									onSend={this.onSave.bind(this)}
									profiles={this.props.profiles}
									producers={this.props.producers}
									/>;
			}} />
			<Route path="/administration/edit/:id" render={(props: any) => {
				const args = props.match.params as any;
				if ((!this.props.current || this.props.current.id !== parseInt(args.id, 10)) || this.props.profiles.length === 0) {
					if (!this.request) {
						this.request = true;
						this.props.onFetchAccount(args.id);
					}
					return <Loading />;
				}
				this.request = false;
				return <FormAccount
				message={this.props.messageFail}
									status={this.props.status}
									isEdit
									onCleanCurrent={this.props.onCleanCurrent}
									onCleanStatus={this.props.onCleanStatus}
									isRequest={this.props.isRequest}
									current={this.props.current}
									history={props.history}
									location={props.location}
									match={props.match}
									onSend={this.onSave.bind(this)}
									profiles={this.props.profiles}
									producers={this.props.producers}
									/>;
			}} />
			<Route
				path="/administration/"
				render={(props) => {
					this.request = false;
					this.id = undefined;
					return <ListAccount
						status={this.props.status}
						setStatusRequest={this.props.setStatusRequest}
						current={this.props.current}
						onFetch={this.props.onFetchAccount}
						onClean={this.onClean.bind(this)}
						onChangeStatus={this.props.onCreateAccount}
						onDelete={this.props.onDeleteAccount}
						profiles={this.props.profiles}
						history={props.history}
						location={props.location}
						match={props.match}
						isRequest={this.props.isRequest}
						onFetchData={this.props.onFetchAccountPage}
						data={this.props.page} /> }
					} />
		</Switch>)
	}

	private onClean() {
		this.props.onCleanStatus();
		this.props.onCleanCurrent();
	}

	private onSave(data: IAccountForm, id?: number) {
		this.props.onCreateAccount(data, id);
	}
}

const mapProps =  (state: IStateApp) => ({...state.account, producers: state.producer.producers, profiles: state.profile.page.data });

const mapActions = (dispatch: any) => ({
	onFetchAccountPage: (options: IPageOptions, idProfile?: number, search?: string, order?: string) => dispatch(createActionfetchAccounts(options, idProfile, search, order)),
	onFetchAccount: (id: number) => dispatch(createActionFetchAccount(id)),
	onFetchProducers: () => dispatch(createActionFetchProducer()),
	onFetchProfiles: () => dispatch(createActionFetchProfiles({ page: 0, size: 100 })),
	onCreateAccount: (data: IAccountForm, id?: number) => dispatch(createActionCreateAccount(data, id)),
	onCleanCurrent: () => dispatch(createActionCleanAccount()),
	onCleanStatus: () => dispatch(createActionCleanAccountStatus()),
	setStatusRequest: (status: EStatusRequest) => dispatch(createActionStatusAccount(status)),
	onDeleteAccount: (id: number) => dispatch(createActionDelete(id))
})

export default connect(mapProps, mapActions)(withRouter(AccountContainer) as any);
